
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('cart', ['products']),

    cartContainsBusinessProducts() {
      return this.products.some((product) => product.onlyBusiness)
    },
  },
}
